import { render } from "./ModelAnswerListHeader.vue?vue&type=template&id=563a7920&ts=true"
import script from "./ModelAnswerListHeader.vue?vue&type=script&lang=ts"
export * from "./ModelAnswerListHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__